'use strict';

exports.__esModule = true;
exports.connect = connect;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _auth = require('../../auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_FACEBOOK: '/customer/facebook'
};

var facebook = {
  connect: connect
};

exports.default = facebook;

/**
 * Wrapper for `/customer` API endpoint
 */

/**
 * Auth with Facebook
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.token] - Facebook oAuth token - required
 * @param {string} [attrs.uid] - Facebook user id
 * @param {string} [attrs.expiresAt] - Facebook oAuth expiry
 * @param {string} [attrs.scope] - App scope
 * @param {string} [attrs.refreshToken] - Facebook oAuth refresh token
 * @returns {promise} containing the auth token
 */

function connect(attrs) {
  return _apiClient2.default.post({ route: API.CUSTOMER_FACEBOOK, data: attrs, includeAuth: false }).then(_auth.createToken);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/facebook/facebook.js
// module id = 1088
// module chunks = 0